// extracted by mini-css-extract-plugin
module.exports = {"modal":"ywl5sc","secondaryButton":"xoGxOG"};